// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReflectionTree - d3-hierarchy tree visualization */

.reflection-tree-toggle {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding-top: 0.4rem;
}

.reflection-tree-toggle button {
  background: none;
  border: 1px solid var(--color-border);
  border-radius: 0.25rem;
  padding: 0.2rem 0.6rem;
  font-size: 0.75rem;
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.reflection-tree-toggle button:hover {
  background: var(--color-surface);
  color: var(--color-text);
}

.tree-toggle-arrow {
  font-size: 0.6rem;
}

.reflection-tree-container {
  padding: 0.5rem 0;
}

/* d3-computed tree layout container */
.tree-layout {
  position: relative;
  margin: 0 auto;
}

/* SVG connector lines layer */
.tree-svg-layer {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}

.tree-connector {
  fill: none;
  stroke: var(--color-border);
  stroke-width: 1;
}

/* Mini card */
.tree-mini-card {
  width: 120px;
  padding: 0.3rem;
  background: var(--color-card-bg);
  border: 1px solid var(--color-border);
  border-radius: 0.4rem;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.tree-mini-card:hover {
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.tree-mini-card.current {
  border-color: var(--color-primary);
  border-width: 2px;
  background: var(--color-active-bg);
}

.tree-mini-card-icon {
  font-size: 1.1rem;
  margin-bottom: 0.15rem;
}

.tree-mini-card-title {
  font-size: 0.65rem;
  font-weight: 500;
  color: var(--color-text);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.3;
}

.tree-mini-card-date {
  font-size: 0.6rem;
  color: var(--color-text-muted);
  margin-top: 0.1rem;
}

/* Placeholder for unanswered suggestions */
.tree-mini-card.placeholder {
  border-style: dashed;
  border-color: var(--color-text-muted);
  opacity: 0.5;
  cursor: default;
}

.tree-mini-card.placeholder:hover {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transform: none;
}

/* NEW indicator for unseen shared reflections */
.tree-mini-card.new {
  border-color: var(--color-primary);
  box-shadow: 0 0 6px rgba(var(--color-primary-rgb, 59, 130, 246), 0.3);
}

.tree-new-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: var(--color-danger, #e74c3c);
  color: #fff;
  font-size: 0.45rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 1px 3px;
  border-radius: 3px;
  line-height: 1;
  z-index: 1;
}

.tree-match-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #27ae60;
  color: #fff;
  font-size: 0.45rem;
  font-weight: 700;
  padding: 1px 3px;
  border-radius: 3px;
  line-height: 1;
  z-index: 1;
  box-shadow: 0 0 6px rgba(39, 174, 96, 0.6), 0 0 12px rgba(39, 174, 96, 0.3);
}

.tree-match-badge.below-new {
  top: 6px;
}

/* Hover tooltip (portal - rendered on document.body) */
.tree-tooltip-portal {
  background: var(--color-card-bg);
  border: 1px solid var(--color-border);
  border-radius: 0.4rem;
  padding: 0.4rem 0.5rem;
  min-width: 140px;
  max-width: 240px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  text-align: left;
  pointer-events: none;
}

.tree-tooltip-question {
  font-size: 0.7rem;
  color: var(--color-text-secondary);
  font-style: italic;
  margin-bottom: 0.25rem;
  line-height: 1.3;
}

.tree-tooltip-title {
  font-size: 0.7rem;
  font-weight: 600;
  color: var(--color-text);
  line-height: 1.3;
}

.tree-tooltip-date {
  font-size: 0.6rem;
  color: var(--color-text-muted);
  margin-top: 0.1rem;
}

.tree-tooltip-media {
  font-size: 0.75rem;
  margin-top: 0.2rem;
  letter-spacing: 0.15em;
}
`, "",{"version":3,"sources":["webpack://./src/components/ReflectionTree.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,qCAAqC;EACrC,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,qCAAqC;EACrC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,kCAAkC;EAClC,qEAAqE;AACvE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,wCAAwC;EACxC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,2EAA2E;AAC7E;;AAEA;EACE,QAAQ;AACV;;AAEA,uDAAuD;AACvD;EACE,gCAAgC;EAChC,qCAAqC;EACrC,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB","sourcesContent":["/* ReflectionTree - d3-hierarchy tree visualization */\n\n.reflection-tree-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding-top: 0.4rem;\n}\n\n.reflection-tree-toggle button {\n  background: none;\n  border: 1px solid var(--color-border);\n  border-radius: 0.25rem;\n  padding: 0.2rem 0.6rem;\n  font-size: 0.75rem;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.reflection-tree-toggle button:hover {\n  background: var(--color-surface);\n  color: var(--color-text);\n}\n\n.tree-toggle-arrow {\n  font-size: 0.6rem;\n}\n\n.reflection-tree-container {\n  padding: 0.5rem 0;\n}\n\n/* d3-computed tree layout container */\n.tree-layout {\n  position: relative;\n  margin: 0 auto;\n}\n\n/* SVG connector lines layer */\n.tree-svg-layer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n\n.tree-connector {\n  fill: none;\n  stroke: var(--color-border);\n  stroke-width: 1;\n}\n\n/* Mini card */\n.tree-mini-card {\n  width: 120px;\n  padding: 0.3rem;\n  background: var(--color-card-bg);\n  border: 1px solid var(--color-border);\n  border-radius: 0.4rem;\n  cursor: pointer;\n  text-align: center;\n  transition: all 0.2s;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.tree-mini-card:hover {\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);\n  transform: translateY(-1px);\n}\n\n.tree-mini-card.current {\n  border-color: var(--color-primary);\n  border-width: 2px;\n  background: var(--color-active-bg);\n}\n\n.tree-mini-card-icon {\n  font-size: 1.1rem;\n  margin-bottom: 0.15rem;\n}\n\n.tree-mini-card-title {\n  font-size: 0.65rem;\n  font-weight: 500;\n  color: var(--color-text);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  line-height: 1.3;\n}\n\n.tree-mini-card-date {\n  font-size: 0.6rem;\n  color: var(--color-text-muted);\n  margin-top: 0.1rem;\n}\n\n/* Placeholder for unanswered suggestions */\n.tree-mini-card.placeholder {\n  border-style: dashed;\n  border-color: var(--color-text-muted);\n  opacity: 0.5;\n  cursor: default;\n}\n\n.tree-mini-card.placeholder:hover {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  transform: none;\n}\n\n/* NEW indicator for unseen shared reflections */\n.tree-mini-card.new {\n  border-color: var(--color-primary);\n  box-shadow: 0 0 6px rgba(var(--color-primary-rgb, 59, 130, 246), 0.3);\n}\n\n.tree-new-badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  background: var(--color-danger, #e74c3c);\n  color: #fff;\n  font-size: 0.45rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  padding: 1px 3px;\n  border-radius: 3px;\n  line-height: 1;\n  z-index: 1;\n}\n\n.tree-match-badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  background: #27ae60;\n  color: #fff;\n  font-size: 0.45rem;\n  font-weight: 700;\n  padding: 1px 3px;\n  border-radius: 3px;\n  line-height: 1;\n  z-index: 1;\n  box-shadow: 0 0 6px rgba(39, 174, 96, 0.6), 0 0 12px rgba(39, 174, 96, 0.3);\n}\n\n.tree-match-badge.below-new {\n  top: 6px;\n}\n\n/* Hover tooltip (portal - rendered on document.body) */\n.tree-tooltip-portal {\n  background: var(--color-card-bg);\n  border: 1px solid var(--color-border);\n  border-radius: 0.4rem;\n  padding: 0.4rem 0.5rem;\n  min-width: 140px;\n  max-width: 240px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  z-index: 10000;\n  text-align: left;\n  pointer-events: none;\n}\n\n.tree-tooltip-question {\n  font-size: 0.7rem;\n  color: var(--color-text-secondary);\n  font-style: italic;\n  margin-bottom: 0.25rem;\n  line-height: 1.3;\n}\n\n.tree-tooltip-title {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: var(--color-text);\n  line-height: 1.3;\n}\n\n.tree-tooltip-date {\n  font-size: 0.6rem;\n  color: var(--color-text-muted);\n  margin-top: 0.1rem;\n}\n\n.tree-tooltip-media {\n  font-size: 0.75rem;\n  margin-top: 0.2rem;\n  letter-spacing: 0.15em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
